import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../../utils/motionVariants';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface PageTransitionProps {
  /** Content to wrap with page transition animation */
  children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps): React.ReactElement {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <>{children}</>;
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
